(function () {
    "use strict";

    angular.module("papp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider.state("parkingPrice", {
            parent: "price",
            url: "/price/parking",
            data: {
                authorities: ["bilioslo-admin", "bilioslo-admin-lese"],
            },
            views: {
                "content@": {
                    templateUrl: "app/price/parking/parking-price.html",
                    controller: "ParkingPriceController",
                    controllerAs: "vm",
                },
            },
        });
    }
})();
